// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-column';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.5 16.5h17M4.423 8.412H2.171c-.29 0-.581.22-.581.588v7.5h3.414V9a.577.577 0 0 0-.58-.588zM10.162 1.5H7.91c-.29 0-.581.22-.581.588v14.338h3.415V2.088c-.073-.294-.291-.588-.582-.588zm5.667 3.456h-2.252a.577.577 0 0 0-.581.588v10.882h3.414V5.544c0-.294-.29-.588-.581-.588z'
  />
);

export const viewBox = '0 0 18 18';
